import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { Sparkles } from "lucide-react";
import { Article } from "@/features/search/types/search";
import CliffNote from "@/features/trending/components/CliffNote";
import CliffNoteLoader from "@/features/trending/components/CliffNoteLoader";
import { CompleteCliffNote } from "@/features/trending/types/CliffNote";

interface GistProps {
  results: Article[];
  query: string;
  isSearching: boolean;
  createCliffNote: (
    query: string,
    results: Article[]
  ) => Promise<CompleteCliffNote | null>;
  isGeneratingCliffNote: boolean;
}

const Gist = ({
  results,
  query,
  createCliffNote,
  isGeneratingCliffNote,
  isSearching,
}: GistProps) => {
  const [cliffNote, setCliffNote] = useState<CompleteCliffNote | null>(null);

  useEffect(() => {
    setCliffNote(null);
  }, [results, isSearching]);

  const handleClick = async () => {
    try {
      const note = await createCliffNote(query, results);
      setCliffNote(note);
    } catch (error) {
      console.error("Error generating cliff note:", error);
    }
  };
  console.log("isGeneratingCliffNote", isGeneratingCliffNote);

  return (
    <div>
      <div className="flex justify-center mb-4">
        {!isGeneratingCliffNote ? (
          !cliffNote && (
            <Button
              onClick={handleClick}
              className="w-full bg-gradient-to-r from-blue-200 to-purple-100 text-black font-medium rounded-lg shadow-sm hover:brightness-105 transition-all flex items-center justify-center gap-2 py-2"
            >
              Just give me the gist{" "}
              <Sparkles size={16} className="text-purple-500" />
            </Button>
          )
        ) : (
          <CliffNoteLoader
            isGeneratingCliffNote={isGeneratingCliffNote}
            articleCount={results.length}
            maxArticles={7}
            isFetchingArticles={true}
          />
        )}
      </div>

      {cliffNote && (
        <CliffNote cliffNote={cliffNote} cliffNoteArticles={results} />
      )}
    </div>
  );
};

export default Gist;
